import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

import { db } from '../firebase/index';
import zepeto_logo from '../static/logo.png';
import zepeto_word_logo from '../static/zepeto_word_logo.png';
import instagram_logo from '../static/instagram_logo.png';

const InputRed = styled.input`
  border: 2px solid #ff4830;
  
  ::placeholder {
    color: #fb8576;
    font-size: 15px;
  }
`
const RedBox = styled.div`
  border: 2px solid #ff4830;
  border-radius: 5px;
  display: inline-block;
  img {
    width: 100%;
  }
`
const MakeButton = styled.button`
  background-color: white;
  border: 2px solid white;
  border-radius: 5px;
`

class Form extends Component {
  state = {
    info: {
      card: this.props.match.params.styleId,
      width: this.props.location.state.width,
      height: this.props.location.state.height,
      name: '',
      description: '',
      zepetoCode: '',
      instagram: '@insta',
      instagramLogo: `${instagram_logo}`,
      instagramField: null,
      zepetoLogo: `${zepeto_logo}`,
      zepetoBigLogo: `${zepeto_word_logo}`,
      kakao: '@kakao',
      kakaoField: null,
      profile: null
    },
    makebtn: 0,
    focus: null,
  }

  componentDidMount() {
    this.getDb();
  }
  componentDidUpdate(prevProps, prevState) {
    const { name, description, zepetoCode } = this.state.info;
    if (prevState.info.name !== name && name) {
      const field = document.getElementsByClassName('name')[0];
      field.focus();
    }
    if (prevState.info.description !== description && description) {
      const field = document.getElementsByClassName('description')[0];
      field.focus();
    }
    if (prevState.info.zepetoCode !== zepetoCode && zepetoCode) {
      const field = document.getElementsByClassName('zepetoCode')[0];
      field.focus();
    }
  }

  handleChange = (e) => {
    this.setState({
      info: {
        ...this.state.info,
        [e.target.name]: e.target.value
      }
    })
  }
  
  handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          info:{
            ...this.state.info,
            profile: e.target.result
          }
        });
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  }
  clickFileUpload = (e) => {
    const input_img = document.getElementsByClassName('input-img')[0];
    input_img.click();
  }

  // card template 정보 받기
  getDb = async () => {
  const { card } = this.state.info;
  const querySnapshot = await db.collection(card).orderBy("order").get();
  let template = {rectangle:[], text:[], image:[]}
  let logos = {}

  querySnapshot.forEach((doc) => {
    const name = doc.data()['name'];
    const oldData = doc.data(); 
    const type = oldData.type;

    // Logo image 받기
    if (type==="image" && oldData.imageUrl) {
      logos[name] = oldData.imageUrl;
    }

    // template 정보 받기
    let newData = {};
    newData['name'] = oldData.name;
    newData['x'] = oldData.marginX;
    newData['y'] = oldData.marginY;
    newData['fill'] = oldData.fill;
    newData['width'] = oldData.width;
    newData['height'] = oldData.height ? oldData.height : oldData.width;
    newData['order'] = oldData.order;
    newData['fontStyle'] = oldData.isBold? 'bold' : '';
    newData['fontSize'] = oldData.fontSize ? oldData.fontSize : 26;
    newData['isTransformable'] = oldData.isTransformable;
    
    template[type].push(newData);
    // template[name] = newData;
    return 0;
    });
    this.setState({
      template: template,
      info: {...this.state.info,
        ...logos}
    });
  }

  clickMakebtn = () => {
    const { makebtn } = this.state;
    this.setState({
      ...this.state,
      makebtn:  makebtn+1
    });
  }

  render() {
    const { info, template } = this.state;
    const { name, description, zepetoCode, profile } = this.state.info;
    // console.log(info);
    // console.log(template);
    return (
      <div className="App">
        <h2>Make your <br />ZEPETO namecard</h2>
        <div className="center">
          <div className="field hidden"><input type="file" accept="image/*" className="input-img" onChange={this.handleImageChange} alt="upload image" /></div>
          
          { this.state.makebtn!==0 && !profile  
            ? <RedBox><img src={this.state.info.profile || 'https://via.placeholder.com/150'} alt="uploaded images" height="150px" onClick={this.clickFileUpload} className="placeholder"/></RedBox>
            : <img src={this.state.info.profile || 'https://via.placeholder.com/150'} alt="uploaded images" height="150px" onClick={this.clickFileUpload} className="placeholder"/> }
          <table className="table">
            <tbody>
              <tr>
                <td><b>Name</b></td>
                <td>
                  { this.state.makebtn!==0 && !name  
                    ? <InputRed onChange={this.handleChange} type="text" name="name" placeholder="please input your name" /> 
                    : <input className="name" onChange={this.handleChange} type="text" name="name" value={name} /> }
                </td>
              </tr>
              <tr>
                <td><b>Job</b></td>
                <td>
                  { this.state.makebtn!==0 && !description  
                      ? <InputRed onChange={this.handleChange} type="text" name="description" placeholder="please input your job" /> 
                      : <input className="description" onChange={this.handleChange} type="text" name="description" value={description} /> }
                </td>
              </tr>
              <tr>
                <td><b>ZEPETO Code</b></td>
                <td>
                  { this.state.makebtn!==0 && !zepetoCode  
                      ? <InputRed onChange={this.handleChange} type="text" name="zepetoCode" placeholder="please input your code" /> 
                      : <input className="zepetoCode" onChange={this.handleChange} type="text" name="zepetoCode" value={zepetoCode} /> }
                </td>
              </tr>
              <tr>
                <td>Instagram</td>
                <td><input 
                onChange={this.handleChange}
                type="text" name="instagram"/></td>
              </tr>
              <tr>
                <td>Kakao</td>
                <td><input 
                onChange={this.handleChange}
                type="text" name="kakao"/></td>
              </tr>
            </tbody>
          </table>
            { name && description && zepetoCode && profile
            ? <Link to={{
              pathname: 'make',
              state: {
                ...info,
                template:template
              },
              exact: true
            }}>
              <MakeButton>Make</MakeButton>
              </Link> 
            : <MakeButton onClick={this.clickMakebtn}>Make</MakeButton>}
            
        </div>
      </div>
    )
  }
}

export default Form;


